import { useEventListener } from 'usehooks-ts'

type MessageHandlerMap<T extends Record<string, unknown>> = {
  [K in keyof T]: (payload: T[K]) => void
}

export function useMessageDispatch<T extends Record<string, unknown>>(
  handlers: MessageHandlerMap<T>,
  expectedOrigin: string,
) {
  useEventListener('message', (event: MessageEvent) => {
    if (event.origin !== expectedOrigin) return
    const { type, payload } = event.data || {}

    if (type in handlers) {
      const handler = handlers[type as keyof T]
      if (typeof handler === 'function') {
        handler(payload)
      }
    }
  })
}
